import { render } from "./InvoiceEditor.vue?vue&type=template&id=c5baf764&scoped=true&ts=true"
import script from "./InvoiceEditor.vue?vue&type=script&lang=ts"
export * from "./InvoiceEditor.vue?vue&type=script&lang=ts"

import "./InvoiceEditor.vue?vue&type=style&index=0&id=c5baf764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5baf764"]])

export default __exports__